import { render, staticRenderFns } from "./EssentialsList.vue?vue&type=template&id=c925d63a&"
import script from "./EssentialsList.vue?vue&type=script&lang=js&"
export * from "./EssentialsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports